import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import RobotImage from "../../assets/images/Robot-with-envelope.png";
import useRecoveryRequest from "../../store/Mutations/useRecoveryRequest ";
import { useToast } from "../../context/ToastProvider";
import GridLGHidden from "../GridComponent/components/GridLGHidden";
import Header from "../Header/Header";
import TextWithBackButton from "../TextWithBackButton";
import Button from "../Button/Button";
import ModalComponent from "../modals/ModalComponent";

const CheckEmailBox = ({ backBtnClick }: { backBtnClick?: () => void }) => {
  const navigate = useNavigate();
  const [notReciveModal, setNotReciveModal] = useState(false);
  const [email, setEmail] = useState<string | null>(null);

  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    setEmail(queryParams.get("email"));
  }, [location.search]);

  useEffect(() => {
    const checkUrlParams = () => {
      const queryParams = new URLSearchParams(window.location.search);
      setEmail(queryParams.get("email"));
    };

    checkUrlParams();

    const handleStorageChange = () => checkUrlParams();
    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const { addToast } = useToast();

  const { mutate } = useRecoveryRequest();

  const handleResendEmail = () => {
    if (email) {
      mutate(
        { email, source: "web" },
        {
          onSuccess: () => {
            addToast({
              headerText: "Email resent",
              message: "Email has been resent successfully",
              type: "success",
            });
          },
        }
      );
    }
  };

  return (
    <>
      <div className="lg:rounded-20 bg-[#FBFBFE] lg:bg-white w-full flex min-h-svh flex-col lg:min-h-fit px-12 lg:p-24">
        <GridLGHidden>
          <Header backgroundColor="[#FBFBFE]" />
        </GridLGHidden>
        <TextWithBackButton
          text="Check your email"
          backBtnClick={() =>
            backBtnClick ? backBtnClick() : navigate("/reset-password")
          }
          subText="We just sent you a password reset link to your email address."
          subText2="If you did not receive it, please check your spam folder or click below."
        />
        <div className="absolute bottom-24 left-0 flex w-full px-12 lg:px-0 flex-col items-center  lg:relative lg:bottom-0 lg:mt-24">
          <img
            src={RobotImage}
            alt=""
            width={300}
            className="mb-[48px] max-lg:mb-[24px] w-[297px] max-lg:[272px]"
          />

          {/* <Divider margin="24" className="mb-0 mt-0 w-full" /> */}
          <Button
            buttonType="secondary"
            title={"I did not receive the email"}
            testID="email-not-recieved"
            styles="mt-12"
            onClick={() => setNotReciveModal(true)}
          />
        </div>
      </div>

      <ModalComponent
        type={"email"}
        withCloseButton={true}
        setOpen={setNotReciveModal}
        open={notReciveModal}
        title={"Did not receive the email?"}
        description={
          "Please check your spam folder to make sure you didn’t miss it. You can also resend the email or contact support."
        }
        primaryButtonText={"Resend email"}
        withCancel={true}
        cancelButtonText={"Close"}
        onCancel={() => {
          setNotReciveModal(false);
        }}
        onSubmit={handleResendEmail}
        onClose={() => {
          setNotReciveModal(false);
        }}
      />
    </>
  );
};

export default CheckEmailBox;
